import React from "react";
import { Box, Button, Modal, useToast } from "fds";
import "./index.scss";
import { nanoid } from "@reduxjs/toolkit";
import { PRODUCT_ITEM_TYPE } from "../../redux/api/appApi";
import useAppStore from "../../redux/dispatcher/useAppStore";
import { PRODUCT_NAME } from "../HeaderUserDropdown/ProfileModal/LinkAppTab";
import { t } from "i18next";

interface AppRegisterModalProps {
  open: boolean;
  onClose: () => void;
  modalType: "CONNECT" | "UNCONNECT"; // CONNECT: 연동 , UNCONNECT:연동 해제
  openLinkAppModal: string; // 연동 정보와 함께 있는 정보
  handleAfter: () => void;
}
const AppRegisterModal: React.FC<AppRegisterModalProps> = ({
  open,
  openLinkAppModal,
  modalType,
  handleAfter,
  onClose,
}) => {
  let type =
    modalType === "CONNECT"
      ? openLinkAppModal.split("open_")[1]
      : openLinkAppModal.split("close_")[1];
  let show_type = type.charAt(0).toUpperCase() + type.slice(1);

  /** Hook 정리 */
  const toasts = useToast();
  const { getAppLoginPage, getAppLoginInfo, doAppLogout } = useAppStore();

  /** 함수 정리 */
  /** 앱 연동 - 앱 연동 동작 */
  const handleRegisterApp = async (type: PRODUCT_ITEM_TYPE) => {
    if (!getAppLoginPage) return;
    const resp = await getAppLoginPage(type);
    let popup: any;
    if (resp.payload) {
      const registURL = resp.payload as any;
      popup = window.open(
        registURL.entity.registUrl,
        `Wrapsody eCo X ${PRODUCT_NAME[type]}`,
        "width=700, height=600, fullscreen=no, directories=no, status=no, toolbar=no, location=no, menubar=no, resizable=yes"
      );
      while (popup && !popup.closed) {
        await new Promise((f) => setTimeout(f, 1000));
      }
      if (popup?.closed) {
        if (!getAppLoginInfo) return;
        let resp1: any = await getAppLoginInfo(type);
        if (resp1.payload && resp1.type.includes("/fulfilled")) {
          toasts.toastMsg(
            nanoid(),
            t("account.app.connetSuccess", { name: PRODUCT_NAME[type] }),
            "success"
          );
          handleAfter && handleAfter();
        } else {
          toasts.toastMsg(
            nanoid(),
            t("account.app.connectFail", { name: PRODUCT_NAME[type] }),
            "error"
          );
          onClose();
        }
      }
    }
  };
  /** 앱 연동 - 앱 연동 해제 동작 */
  const handleUnRegisterApp = async (type: string) => {
    let show_type = type.charAt(0).toUpperCase() + type.slice(1);
    let resp = await doAppLogout(type === "zoom" ? "zoom" : "dropbox");
    if (resp && resp.meta.requestStatus === "fulfilled") {
      toasts.toastMsg(
        nanoid(),
        t("account.app.removeSuccess", { name: show_type }),
        "success"
      );
    } else {
      toasts.toastMsg(
        nanoid(),
        t("account.app.removeFail", { name: show_type }),
        "error"
      );
    }
    onClose();
  };
  return (
    <Modal
      width={540}
      open={open}
      onClose={onClose}
      classes="appRegisterModal"
      title={
        modalType === "CONNECT"
          ? t("header.linkApp.connectTitle", { name: show_type })
          : t("header.linkApp.disconnectTitle", { name: show_type })
      }
      bodyMsg={
        modalType === "CONNECT"
          ? t("header.linkApp.connectBody", { name: show_type })
          : t("header.linkApp.disconnectBody", { name: show_type })
      }
      footer={
        <Box>
          <Button
            label={t("common.cancel")}
            btnStyle="fill"
            type="secondary"
            onClick={onClose}
          />
          <Button
            label={
              modalType === "CONNECT"
                ? t("common.continue")
                : t("header.linkApp.disconnect")
            }
            btnStyle="fill"
            onClick={() =>
              modalType === "CONNECT"
                ? handleRegisterApp(type === "zoom" ? "zoom" : "dropbox")
                : handleUnRegisterApp(type)
            }
          />
        </Box>
      }
    />
  );
};
export default AppRegisterModal;
